// SDQ (Strengths and Difficulties Questionnaire) Assessment Questions
// Based on the 11-17 self-report follow-up version with 25 questions
// Subscales: Emotional Symptoms (e), Conduct Problems (c), Hyperactivity (h), Peer Problems (p), Prosocial Behavior (pro)

export const sdqQuestions = [
  {
    id: 1,
    type: 'pro', // prosocial
    question: "I try to be nice to other people. I care about their feelings",
    questionFil: "Sinisikap kong maging mabait sa iba. May pakialam ako sa kanilang damdamin",
    examples: [
      "Comforting a friend who is sad",
      "Saying 'please' and 'thank you' to others",
      "Helping someone who dropped their books"
    ],
    examplesFil: [
      "Pag-comfort sa kaibigan na malungkot",
      "Pagsasabi ng 'please' at 'thank you' sa iba",
      "Pagtulong sa nahulog ang mga libro"
    ]
  },
  {
    id: 2,
    type: 'h', // hyperactivity
    question: "I am restless, I cannot stay still for long",
    questionFil: "Hindi ako mapakali, hindi ako makatagal na nakaupo o nakatayo",
    examples: [
      "Fidgeting during long classes or meetings",
      "Needing to get up and walk around frequently",
      "Tapping your foot or fingers when sitting"
    ],
    examplesFil: [
      "Hindi makapag-stay still sa mahabang klase o meeting",
      "Kailangang tumayo at maglakad-lakad",
      "Pag-tap ng paa o daliri kapag nakaupo"
    ]
  },
  {
    id: 3,
    type: 'e', // emotional
    question: "I get a lot of headaches, stomach-aches or sickness",
    questionFil: "Madalas ako masakit ang ulo, tiyan, o magkakasakit",
    examples: [
      "Getting headaches when stressed about school",
      "Stomach aches before important events",
      "Feeling sick when worried or anxious"
    ],
    examplesFil: [
      "Sumasakit ang ulo kapag stressed sa school",
      "Sumasakit ang tiyan bago ang important events",
      "Nagiging masama ang pakiramdam kapag worried"
    ]
  },
  {
    id: 4,
    type: 'pro', // prosocial
    question: "I usually share with others, for example CDs, games, food",
    questionFil: "Kadalasan ay nagbabahagi ako sa iba, tulad ng mga CD, laro, pagkain",
    examples: [
      "Sharing your snacks with classmates",
      "Letting friends borrow your games or books",
      "Offering to share your lunch with someone"
    ],
    examplesFil: [
      "Pagbabahagi ng snacks sa mga classmate",
      "Pagpapahiram ng games o books sa mga kaibigan",
      "Pag-offer na magbahagi ng lunch sa iba"
    ]
  },
  {
    id: 5,
    type: 'c', // conduct
    question: "I get very angry and often lose my temper",
    questionFil: "Sobrang nagagalit ako at madalas nawala ang kontrol sa sarili",
    examples: [
      "Shouting when things don't go your way",
      "Getting into arguments over small things",
      "Feeling rage that's hard to control"
    ],
    examplesFil: [
      "Pagsigaw kapag hindi natupad ang gusto",
      "Pag-away dahil sa maliliit na bagay",
      "Pakiramdam ng galit na mahirap kontrolin"
    ]
  },
  {
    id: 6,
    type: 'p', // peer
    question: "I would rather be alone than with people of my age",
    questionFil: "Mas gusto kong mag-isa kaysa makasama ang mga taong kaedad ko",
    examples: [
      "Preferring to eat lunch alone rather than with classmates",
      "Choosing to stay home instead of going to parties",
      "Feeling more comfortable by yourself than in groups"
    ],
    examplesFil: [
      "Mas gusto mag-lunch mag-isa kaysa sa mga classmate",
      "Pagpili na manatili sa bahay kaysa pumunta sa party",
      "Mas komportable mag-isa kaysa sa grupo"
    ]
  },
  {
    id: 7,
    type: 'c', // conduct (reverse scored)
    question: "I usually do as I am told",
    questionFil: "Kadalasan ay sumusunod ako sa sinasabi sa akin",
    reverse_scored: true
  },
  {
    id: 8,
    type: 'e', // emotional
    question: "I worry a lot",
    questionFil: "Sobrang nag-aalala ako",
    examples: [
      "Constantly thinking about upcoming tests or assignments",
      "Worrying about what others think of you",
      "Feeling anxious about things that might go wrong"
    ],
    examplesFil: [
      "Palaging nag-iisip tungkol sa mga test o assignment",
      "Nag-aalala sa iniisip ng iba tungkol sa'yo",
      "Kinakabahan sa mga bagay na pwedeng magkaproblema"
    ]
  },
  {
    id: 9,
    type: 'pro', // prosocial
    question: "I am helpful if someone is hurt, upset or feeling ill",
    questionFil: "Tumutulong ako kapag may nasaktan, nalungkot, o nagkakasakit",
    examples: [
      "Helping someone who fell down or got injured",
      "Comforting a friend who is crying",
      "Getting help for someone who feels sick"
    ],
    examplesFil: [
      "Pagtulong sa nahulog o nasaktan",
      "Pag-comfort sa kaibigan na umiiyak",
      "Pagkuha ng tulong para sa may sakit"
    ]
  },
  {
    id: 10,
    type: 'h', // hyperactivity
    question: "I am constantly fidgeting or squirming",
    questionFil: "Palaging gumagalaw-galaw o hindi mapakali ang katawan ko"
  },
  {
    id: 11,
    type: 'p', // peer (reverse scored)
    question: "I have one good friend or more",
    questionFil: "May isa o higit pang matalik na kaibigan ako",
    reverse_scored: true
  },
  {
    id: 12,
    type: 'c', // conduct
    question: "I fight a lot. I can make other people do what I want",
    questionFil: "Madalas ako nag-aaway. Kayang-kaya kong paggawin sa iba ang gusto ko"
  },
  {
    id: 13,
    type: 'e', // emotional
    question: "I am often unhappy, depressed or tearful",
    questionFil: "Madalas akong malungkot, depressed, o umiiyak"
  },
  {
    id: 14,
    type: 'p', // peer (reverse scored)
    question: "Other people my age generally like me",
    questionFil: "Sa pangkalahatan, gusto ako ng mga taong kaedad ko",
    reverse_scored: true
  },
  {
    id: 15,
    type: 'h', // hyperactivity
    question: "I am easily distracted, I find it difficult to concentrate",
    questionFil: "Madaling nakakalimutan ang attention ko, hirap akong mag-concentrate"
  },
  {
    id: 16,
    type: 'e', // emotional
    question: "I am nervous in new situations. I easily lose confidence",
    questionFil: "Kinakabahan ako sa mga bagong sitwasyon. Madaling nawawala ang confidence ko"
  },
  {
    id: 17,
    type: 'pro', // prosocial
    question: "I am kind to younger children",
    questionFil: "Mabait ako sa mga batang mas bata sa akin"
  },
  {
    id: 18,
    type: 'c', // conduct
    question: "I am often accused of lying or cheating",
    questionFil: "Madalas akong naaakusahan na nagsisinungaling o nandadaya"
  },
  {
    id: 19,
    type: 'p', // peer
    question: "Other children or young people pick on me or bully me",
    questionFil: "Ginagago o binubully ako ng ibang mga bata o kabataan"
  },
  {
    id: 20,
    type: 'pro', // prosocial
    question: "I often offer to help others (parents, teachers, children)",
    questionFil: "Madalas akong nag-aalok na tumulong sa iba (mga magulang, guro, bata)"
  },
  {
    id: 21,
    type: 'h', // hyperactivity (reverse scored)
    question: "I think before I do things",
    questionFil: "Nag-iisip muna ako bago gawin ang mga bagay",
    reverse_scored: true
  },
  {
    id: 22,
    type: 'c', // conduct
    question: "I take things that are not mine from home, school or elsewhere",
    questionFil: "Kinukuha ko ang mga bagay na hindi sa akin mula sa bahay, school, o sa ibang lugar"
  },
  {
    id: 23,
    type: 'p', // peer
    question: "I get along better with adults than with people my own age",
    questionFil: "Mas nakakasundo ko ang mga matatanda kaysa sa mga kaedad ko"
  },
  {
    id: 24,
    type: 'e', // emotional
    question: "I have many fears, I am easily scared",
    questionFil: "Marami akong takot, madaling matakot"
  },
  {
    id: 25,
    type: 'h', // hyperactivity (reverse scored)
    question: "I finish the work I'm doing. My attention is good",
    questionFil: "Nataatapos ko ang mga ginagawa ko. Maganda ang attention ko",
    reverse_scored: true
  }
];

// Response options for SDQ (3-point Likert scale)
export const sdqRatingScale = [
  {
    value: 0,
    label: "Not True",
    labelFil: "Hindi Totoo"
  },
  {
    value: 1,
    label: "Somewhat True",
    labelFil: "Medyo Totoo"
  },
  {
    value: 2,
    label: "Certainly True",
    labelFil: "Talagang Totoo"
  }
];

// Scoring function
export const calculateSDQScores = (responses) => {
  let emotional = 0;
  let conduct = 0;
  let hyperactivity = 0;
  let peer = 0;
  let prosocial = 0;

  sdqQuestions.forEach((question, index) => {
    // Use array index since responses is 0-based array
    const response = responses[index] !== undefined ? responses[index] : 0;

    // Handle reverse scoring
    const score = question.reverse_scored ? (2 - response) : response;

    switch (question.type) {
      case 'e':
        emotional += score;
        break;
      case 'c':
        conduct += score;
        break;
      case 'h':
        hyperactivity += score;
        break;
      case 'p':
        peer += score;
        break;
      case 'pro':
        prosocial += score;
        break;
    }
  });

  // Total difficulties score (sum of first 4 subscales, excludes prosocial)
  const totalDifficulties = emotional + conduct + hyperactivity + peer;

  // Composite scores
  const internalising = emotional + peer;  // Internalising problems
  const externalising = conduct + hyperactivity;  // Externalising problems

  return {
    emotional_symptoms: emotional,
    conduct_problems: conduct,
    hyperactivity: hyperactivity,
    peer_problems: peer,
    prosocial: prosocial,
    total_difficulties: totalDifficulties,
    internalising: internalising,
    externalising: externalising
  };
};

// Severity interpretation for SDQ (11-17 self-report version) - 4-band system
// Based on OFFICIAL Self-Completed SDQ normative data
export const getSDQSeverity = (scores) => {
  const getSeverityLevel = (score, thresholds) => {
    if (score <= thresholds.close_avg) return 'Close to Average';
    if (score <= thresholds.slightly_raised) return 'Slightly Raised';
    if (score <= thresholds.high) return 'High';
    return 'Very High';
  };

  // Self-report prosocial bands: 7-10, 6, 5, 0-4 (must match SDQUtils on the backend)
  const getProsocialSeverity = (score) => {
    if (score >= 7) return 'Close to Average';
    if (score >= 6) return 'Slightly Lowered';
    if (score >= 5) return 'Low';
    return 'Very Low';
  };

  return {
    emotional_symptoms: getSeverityLevel(scores.emotional_symptoms, {
      close_avg: 4,
      slightly_raised: 5,
      high: 6
    }),
    conduct_problems: getSeverityLevel(scores.conduct_problems, {
      close_avg: 3,
      slightly_raised: 4,
      high: 5
    }),
    hyperactivity: getSeverityLevel(scores.hyperactivity, {
      close_avg: 5,
      slightly_raised: 6,
      high: 7
    }),
    peer_problems: getSeverityLevel(scores.peer_problems, {
      close_avg: 2,
      slightly_raised: 3,
      high: 4
    }),
    prosocial: getProsocialSeverity(scores.prosocial),
    total_difficulties: getSeverityLevel(scores.total_difficulties, {
      close_avg: 14,
      slightly_raised: 17,
      high: 19
    }),
    internalising: getSeverityLevel(scores.internalising, {
      close_avg: 6,
      slightly_raised: 8,
      high: 10
    }),
    externalising: getSeverityLevel(scores.externalising, {
      close_avg: 8,
      slightly_raised: 10,
      high: 12
    })
  };
};

// SDQ subscale item mappings for reference
export const sdqSubscales = {
  emotional_symptoms: [3, 8, 13, 16, 24],      // Questions 3, 8, 13, 16, 24
  conduct_problems: [5, 7, 12, 18, 22],        // Questions 5, 7(R), 12, 18, 22
  hyperactivity: [2, 10, 15, 21, 25],          // Questions 2, 10, 15, 21(R), 25(R)
  peer_problems: [6, 11, 14, 19, 23],          // Questions 6, 11(R), 14(R), 19, 23
  prosocial: [1, 4, 9, 17, 20]                 // Questions 1, 4, 9, 17, 20
};

// Generate interpretation text
export const generateSDQInterpretation = (scores, severities) => {
  const interpretations = [];
  
  interpretations.push(`Emotional Symptoms: ${scores.emotional_symptoms}/10 (${severities.emotional_symptoms})`);
  interpretations.push(`Conduct Problems: ${scores.conduct_problems}/10 (${severities.conduct_problems})`);
  interpretations.push(`Hyperactivity: ${scores.hyperactivity}/10 (${severities.hyperactivity})`);
  interpretations.push(`Peer Problems: ${scores.peer_problems}/10 (${severities.peer_problems})`);
  interpretations.push(`Prosocial Behavior: ${scores.prosocial}/10 (${severities.prosocial})`);
  interpretations.push(`Total Difficulties: ${scores.total_difficulties}/40 (${severities.total_difficulties})`);
  
  return interpretations.join('\n');
};